import React from 'react';
import { cn } from '@/lib/utils';

export const Skel = ({ className }) => <div className={cn('skeleton', className)} />;

export const KpiSkeleton = () => (
  <div className="rounded-xl bg-white border border-[#ECEEF2] shadow-card p-5">
    <Skel className="h-3 w-24" />
    <Skel className="h-8 w-32 mt-3" />
    <Skel className="h-3 w-28 mt-3" />
  </div>
);

export const KpiRowSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
    {Array.from({ length: count }).map((_, i) => <KpiSkeleton key={i} />)}
  </div>
);

export const TableSkeleton = ({ rows = 6 }) => (
  <div className="surface overflow-hidden">
    <div className="px-5 py-3 border-b border-[#ECEEF2]"><Skel className="h-4 w-40" /></div>
    <div className="divide-y divide-[#F1F2F5]">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="px-5 py-3.5 flex items-center gap-4">
          <Skel className="h-4 flex-1" />
          <Skel className="h-4 w-24" />
          <Skel className="h-4 w-16" />
          <Skel className="h-4 w-20" />
        </div>
      ))}
    </div>
  </div>
);

export const CardsSkeleton = ({ count = 3 }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-xl bg-white border border-[#ECEEF2] shadow-card p-5">
        <Skel className="h-4 w-2/3" /><Skel className="h-8 w-1/2 mt-4" /><Skel className="h-3 w-full mt-4" />
      </div>
    ))}
  </div>
);
